import { Flex } from '@chakra-ui/react';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { FormFeedback, Input } from '@morressier/alembic';
import { FieldLabel } from 'src/components/Field';
import { TITLE_CHARACTER_LIMIT } from '../constants';
import { trimLeadingWhitespace, validateLabelWhenNoContent } from '../helpers';
import { FieldFormValues } from '../../../helpers/articleTypeConfig.types';

type Props = {
  control: Control<FieldFormValues>;
  errors: FieldErrors<FieldFormValues>;
  isFormDisabled: boolean;
};

const LabelTitleField: React.FC<Props> = ({
  control,
  errors,
  isFormDisabled,
}) => {
  return (
    <Flex direction="column" gap={2}>
      <FieldLabel label="Title" subText="" isRequired />

      <Controller
        name="labelTitle"
        control={control}
        rules={{
          validate: value =>
            validateLabelWhenNoContent({
              value,
              label: 'Title',
              isDisabled: isFormDisabled,
              isRequired: true
            }),
          maxLength: {
            value: TITLE_CHARACTER_LIMIT,
            message: `Title cannot exceed ${TITLE_CHARACTER_LIMIT} characters`
          }
        }}
        render={({ field }) => (
          <Input
            name={field.name}
            value={field.value}
            onChange={event =>
              field.onChange(trimLeadingWhitespace(event.target.value))
            }
            placeholder="Label title"
            maxLength={TITLE_CHARACTER_LIMIT}
            invalid={!isFormDisabled && Boolean(errors.labelTitle)}
            disabled={isFormDisabled}
          />
        )}
      />

      {!isFormDisabled && errors.labelTitle ? (
        <FormFeedback variant="error">{errors.labelTitle.message}</FormFeedback>
      ) : null}
    </Flex>
  );
};

export default LabelTitleField;
